import { render, staticRenderFns } from "./setMealList.vue?vue&type=template&id=60aacad6&scoped=true&"
import script from "./setMealList.vue?vue&type=script&lang=js&"
export * from "./setMealList.vue?vue&type=script&lang=js&"
import style0 from "./setMealList.vue?vue&type=style&index=0&id=60aacad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aacad6",
  null
  
)

export default component.exports